import { render, staticRenderFns } from "./medical-analyses-report-table.vue?vue&type=template&id=88fbdd88&scoped=true&"
import script from "./medical-analyses-report-table.vue?vue&type=script&lang=js&"
export * from "./medical-analyses-report-table.vue?vue&type=script&lang=js&"
import style0 from "../scss/table.scss?vue&type=style&index=0&id=88fbdd88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fbdd88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88fbdd88')) {
      api.createRecord('88fbdd88', component.options)
    } else {
      api.reload('88fbdd88', component.options)
    }
    module.hot.accept("./medical-analyses-report-table.vue?vue&type=template&id=88fbdd88&scoped=true&", function () {
      api.rerender('88fbdd88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reports/medical-analyses/components/medical-analyses-report-table.vue"
export default component.exports